// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
const React = require('react')
// Client V2 common imports
const { wrapDisplayName } = require('client-v2/common/components/utils')
const tag = require('client-v2/common/utils/hyperscript')

/**
 * A Higher-Order-Component to slice `props.items` into pages
 */
function withPageSlicer(wrappedComponent) {
  function PageSlicer(props) {
    const { items, pageCount, pageSize, pageStart } = props
    const slicedItems = React.useMemo(
      () => {
        // Treat pageStart: 0 and pageStart: 1 as the first page
        const itemStart = pageStart < 2 ? 0 : pageSize * (pageStart - 1)
        // Treat pageCount: 0 as "the rest of the pages"
        const itemEnd = pageCount ? itemStart + (pageSize * pageCount) : undefined
        return items.slice(itemStart, itemEnd)
      },
      [ items, pageCount, pageSize, pageStart ]
    )
    return tag(wrappedComponent, { ...props, items: slicedItems })
  }

  PageSlicer.displayName = wrapDisplayName(PageSlicer, wrappedComponent)

  PageSlicer.propTypes = {
    items: PropTypes.oneOfType([
      PropTypes.instanceOf(Array),
      PropTypes.instanceOf(Immutable.Iterable)
    ]).isRequired,
    pageCount: PropTypes.number,
    pageSize: PropTypes.number.isRequired,
    pageStart: PropTypes.number
  }

  return React.memo(PageSlicer)
}

module.exports = withPageSlicer
